import React from 'react';

import Dropdown, { DropdownProps } from '../../atoms/dropdown/Dropdown';
import Text from '../../atoms/text/Text';

export interface SectionHeaderProps {
  testId?: string;
  title?: string;
  subtitle?: string;
  titleColor?: string;
  subTitleColor?: string;
  dropdown?: DropdownProps;
  components?: React.JSX.Element[];
}

const SectionHeader = ({
  testId,
  titleColor = 'title',
  title,
  subtitle,
  subTitleColor = 'subtitle1',
  dropdown,
  components = [],
}: SectionHeaderProps) => {
  return (
    <div
      className="d-flex justify-content-between align-items-start w-100 border-bottom pb-16"
      data-testid={testId}
    >
      <div className="d-flex flex-wrap justify-content-between align-items-start gap-8 w-100">
        <div className="d-flex flex-column">
          <Text color={titleColor} size="lg" weight="semibold" component="h2">
            {title}
          </Text>
          <Text color={subTitleColor} size="sm" component="p">
            {subtitle}
          </Text>
        </div>
        <div className="d-flex gap-6 flex-wrap">
          {Array.isArray(components) &&
            components.length > 0 &&
            components.map((item, _idx) => (
              <React.Fragment key={_idx}>{item}</React.Fragment>
            ))}
        </div>
      </div>

      {dropdown && <Dropdown {...dropdown} />}
    </div>
  );
};

export default SectionHeader;
